// extracted by mini-css-extract-plugin
export var container = "about-module--container--2PnG_";
export var wrap = "about-module--wrap--3E9dc";
export var pc = "about-module--pc--1oJuv";
export var pcImage = "about-module--pc-image--2mmws";